import $ from 'jquery';
import 'slick-carousel'

export default class NumberIconSteps {
    constructor() {
       this.$slider =  $('.number-icon-steps__steps');
       this.maxSliderWidth = 768;
       this.showing = false;

       if( $(window).width() < this.maxSliderWidth ){
           this.initSlider();
       }

        $(window).on('resize orientationchange', (e) => {
            if( this.showing === true )
                this.$slider.slick('resize');

            if( $(window).width() < this.maxSliderWidth && this.showing === false )
                this.initSlider();
            else if( $(window).width() > this.maxSliderWidth && this.showing === true )
                this.destroySlider();
        });
    }

    initSlider() {
        this.showing = true;

        this.$slider.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true
        });
    }

    destroySlider() {
        if( this.showing === true ){
            this.showing = false;

            this.$slider.slick('unslick');
        }
    }
}

new NumberIconSteps();
